import { useCallback } from 'react';

type PossibleRef<T> = React.Ref<T> | undefined;

/**
 * Merges multiple refs into a single callback ref.
 * This is useful when you need to pass multiple refs to a single element.
 */
export function useMergedRefs<T>(...refs: PossibleRef<T>[]) {
  return useCallback(
    (node: T | null) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref != null) {
          (ref as React.MutableRefObject<T | null>).current = node;
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs,
  );
}
